import React, { useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    Button,
    Alert,
    Divider,
    CircularProgress,
    Stack
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../components/AuthContext'; // Ajuste o path se necessário
import { API_BASE_URL } from '../components/api.js';

// Helper para formatar data para o backend (YYYY-MM-DD)
const formatDate = (date) =>
    date
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
        : null;

function InteligenciaProcessar() {
    const { authenticatedFetch, logout } = useAuth();

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // { type: 'success' | 'error', msg: string }

    const handleRecalcular = async () => {
        const isTotal = !startDate && !endDate;
        const msgConfirma = isTotal
            ? "Deseja recalcular TODO o histórico? Isso pode levar alguns minutos."
            : "Deseja recalcular o período selecionado?";

        if (!window.confirm(msgConfirma)) return;

        setLoading(true);
        setStatus(null);

        const payload = {
            inicio: formatDate(startDate),
            fim: formatDate(endDate)
        };

        try {
            const response = await authenticatedFetch(`${API_BASE_URL}/api/inteligencia-processar-repopular/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                if (response.status === 401) logout();
                const errData = await response.json().catch(() => ({}));
                throw new Error(errData.error || `Erro ${response.status}`);
            }

            const data = await response.json();
            setStatus({ type: 'success', msg: data.message });
        } catch (err) {
            setStatus({ type: 'error', msg: err.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ flexGrow: 1, p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant="h5" fontWeight="bold">
                Processar Inteligência de Vendas
            </Typography>

            <Paper elevation={3} sx={{ p: 3, maxWidth: 600, display: 'flex', flexDirection: 'column', gap: 3 }}>
                
                <Box>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Recalcular Pães e Faturamento
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Esta ação reconstrói a base de inteligência aplicando as regras de Sub Series, 
                        fuso horário e impactos de feriados.
                    </Typography>
                </Box>

                <Divider />

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <DatePicker
                            label="Data Inicial"
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            format="dd/MM/yyyy"
                            slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        />
                        <DatePicker
                            label="Data Final"
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            format="dd/MM/yyyy"
                            slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        />
                    </Stack>
                </LocalizationProvider>

                {!startDate && !endDate && (
                    <Alert severity="warning" icon={<WarningAmberIcon fontSize="inherit" />}>
                        Nenhuma data selecionada: O sistema processará <strong>todo o histórico</strong> disponível.
                    </Alert>
                )}

                <Box sx={{ mt: 1 }}>
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PlayArrowIcon />}
                        onClick={handleRecalcular}
                        disabled={loading}
                        sx={{ px: 4, py: 1.2, fontWeight: 'bold' }}
                    >
                        {loading ? 'Processando...' : 'Iniciar Recalculo'}
                    </Button>
                </Box>

                {status && (
                    <Alert severity={status.type} sx={{ mt: 1 }}>
                        {status.msg}
                    </Alert>
                )}
            </Paper>
        </Box>
    );
}

export default InteligenciaProcessar;